module.exports = __webpack_public_path__ + "r-v3/img/crown_blue.beea2e6c.svg";